export default "__VITE_ASSET__58d13d32__"